import React, { useContext, useEffect, useState } from "react";
import "./Wallet.css";
import EstoreBannerImg from "../../assets/images/new/E-Storebanner.png";
import {
  GetUserWalletAmount,
  GetWalletTransactionList,
} from "../../ApiServices/UserWallet/UserWalletApi";
import { LoaderContext } from "../../AuthContext/AuthContext";
import dayjs from "dayjs";
import DownloadApp from "../DownLoadApp/DownloadApp";
const WalletList = () => {
  const [transactionData, setTransactionData] = useState([]);
  const { setLoader } = useContext(LoaderContext);
  const userID = localStorage.getItem("userID");
  const userKeyID = localStorage.getItem("userKeyID");
  const [walletAmount, setWalletAmount] = useState(0);
  const data = [
    {
      date: "25/05/25",
      Description: "Desc",
      debitAmount: 2500,
      creditAmount: 300,
      balanceAmount: 12000,
    },
    {
      date: "25/05/25",
      Description: "Desc",
      debitAmount: 2500,
      creditAmount: 300,
      balanceAmount: 12000,
    },
    {
      date: "25/05/25",
      Description: "Desc",
      debitAmount: 2500,
      creditAmount: 300,
      balanceAmount: 12000,
    },
    {
      date: "25/05/25",
      Description: "Desc",
      debitAmount: 2500,
      creditAmount: 300,
      balanceAmount: 12000,
    },
  ];
  useEffect(() => {
    GetWalletTransactionListData();
    GetUserWalletAmountData();
  }, []);
  const GetUserWalletAmountData = async () => {
    setLoader(true);
    try {
      let response = await GetUserWalletAmount(userKeyID); // Replace with actual import/function call
      if (response?.statusCode === 200) {
        setLoader(false);

        const list = response?.responseData?.data
        setWalletAmount(Number(list) <= 0 ? 0 : list)

      } else {
        console.error("Bad request");
        setLoader(false);
      }

    } catch (error) {
      console.log(error);
      setLoader(false);
    }
  };

  const GetWalletTransactionListData = async () => {
    setLoader(true);
    try {
      let response = await GetWalletTransactionList(userID); // Replace with actual import/function call
      if (response?.ResponseCode == "0") {
        setLoader(false);
        const list = response?.DATA || [];
        setTransactionData(list);

      } else {
        console.error("Bad request");
        setLoader(false);
      }
    } catch (error) {
      console.log(error);
      setLoader(false);
    }
  };

  return (
    <>
      <section className="page-header">
        <div
          className="page-header__bg"
          style={{ backgroundImage: `url(${EstoreBannerImg})` }}
        ></div>
        <div className="container">
          <h2 className="page-header__title bw-split-in-left">My Wallet</h2>
        </div>
      </section>
      <div
        className="container d-flex flex-column align-items-center justify-content-center wallet-responsive"
        style={{

          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          padding: "40px 10px",

        }}
      >
        <div
          className="wallet-history-section"
          style={{
            width: "100%",
            maxWidth: "800px",
            textAlign: "center",
          }}
        >
          {/* Wallet Header */}
          <div
            className="wallet-balance shadow-lg p-4 text-center"
            style={{
              borderRadius: "20px",
              background: "linear-gradient(135deg, #fff0f5, #f8f9fa)",
              transition: "all 0.3s ease-in-out",
              position: "relative",
              overflow: "hidden",
              boxShadow: "0 6px 20px rgba(0,0,0,0.08)",
              border: "1px dashed #a52444",
              marginBottom: "30px",
            }}
          >
            {/* Background Floating Circle */}


            {/* Wallet Header */}
            <div
              className="balance-box d-flex flex-column align-items-center justify-content-center mb-3"
              style={{ position: "relative", zIndex: 2 }}
            >
              <div
                className="wallet-icon d-flex align-items-center justify-content-center "
                style={{
                  width: "80px",
                  height: "80px",
                  borderRadius: "50%",
                  background: "#a52444",
                  color: "#fff",
                  fontSize: "35px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  boxShadow: "0 5px 15px rgba(165, 36, 68, 0.4)",
                  transform: "scale(1)",
                  transition: "transform 0.3s ease-in-out",
                  cursor: "pointer",
                }}
                onMouseEnter={(e) => (e.currentTarget.style.transform = "scale(1.1)")}
                onMouseLeave={(e) => (e.currentTarget.style.transform = "scale(1)")}
              >
                <i className="icofont-wallet"></i>
              </div>

              <span
                className="amount fw-bold"
                style={{
                  fontSize: "32px",
                  color: "#212529",
                  marginBottom: "5px",
                  letterSpacing: "0.5px",
                }}
              >
                ₹ {walletAmount}
              </span>
              <p
                className="wallet-subtext"
                style={{
                  color: "#6c757d",
                  fontSize: "14px",
                  marginBottom: 0,
                }}
              >
                (Available Wallet Balance)
              </p>
            </div>

            {/* Empty Wallet Section */}
            {walletAmount === 0 && (
              <div
                className="empty-wallet-section mt-4 p-4"
                style={{
                  background: "#fff6f8",
                  borderRadius: "16px",
                  boxShadow: "0 2px 8px rgba(0,0,0,0.05)",
                  position: "relative",
                  zIndex: 2,
                  transform: "translateY(0px)",
                  transition: "transform 0.3s ease-in-out",
                }}
                onMouseEnter={(e) =>
                  (e.currentTarget.style.transform = "translateY(-5px)")
                }
                onMouseLeave={(e) =>
                  (e.currentTarget.style.transform = "translateY(0px)")
                }
              >
                <h4
                  className="fw-semibold mb-3"
                  style={{
                    color: "#a52444",
                    fontWeight: 600,
                    marginBottom: "10px",
                  }}
                >
                  Your Wallet is Empty!
                </h4>
                <p
                  className="wallet-paragraph-css"
                  style={{
                    color: "#555",
                    fontSize: "16px",
                    lineHeight: "1.6",
                    maxWidth: "600px",
                    margin: "0 auto",
                  }}
                >
                  Don't worry — you can earn wallet credits easily.
                  <br />
                  Download our app and share it with your friends. When they sign up
                  and book a service or puja, you'll receive wallet rewards instantly!
                  <br />
                  <strong>Start sharing and get rewarded today!</strong>
                </p>


              </div>
            )}
          </div>

          {/* Transaction History Table */}
          <div
            className="wallet-table-wrapper"
            style={{
              width: "100%",
              margin: "0 auto",
              textAlign: "center",
            }}
          >
            {transactionData?.length > 0 ? (
              <div
                className="card p-3"
                style={{
                  borderRadius: "12px",
                  boxShadow: "0 4px 12px rgba(0,0,0,0.08)",
                  overflowX: "auto",
                }}
              >
                <table
                  className="wallet-table"
                  style={{
                    width: "100%",
                    borderCollapse: "collapse",
                    fontSize: "15px",
                    color: "#333",
                  }}
                >
                  <thead>
                    <tr style={{ backgroundColor: "#a52444", color: "#fff" }}>
                      <th style={{ padding: "10px" }}>Date</th>
                      <th style={{ padding: "10px" }}>Description</th>
                      <th style={{ padding: "10px" }}>Debit Amount (₹)</th>
                      <th style={{ padding: "10px" }}>Credit Amount (₹)</th>
                      <th style={{ padding: "10px" }}>Bal. Amount (₹)</th>
                    </tr>
                  </thead>
                  <tbody>
                    {transactionData.map((value, index) => (
                      <tr
                        key={index}
                        style={{
                          backgroundColor: index % 2 === 0 ? "#fff" : "#f8f8f8",
                          borderBottom: "1px solid #ddd",
                        }}
                      >
                        <td style={{ padding: "10px" }}>
                          {dayjs(value.RegDate).format("DD/MM/YYYY") || "N/A"}
                        </td>
                        <td style={{ padding: "10px" }}>
                          {value.Description || "N/A"}
                        </td>
                        <td style={{ padding: "10px" }}>
                          {value.Debit?.toFixed(2) || "0.00"}
                        </td>
                        <td style={{ padding: "10px" }}>
                          {value.Credit?.toFixed(2) || "0.00"}
                        </td>
                        <td style={{ padding: "10px" }}>
                          {value.Amount?.toFixed(2) || "0.00"}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            ) : (
              ""
            )}
          </div>
        </div>
      </div>

      <DownloadApp />
    </>
  );
};

export default WalletList;
